import React, { useState } from 'react';
import { Modal, Form, Input, Button, Typography, Space, Alert, message } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import axios from 'axios';

const { Text, Title } = Typography;
const { OTP } = Input;

const TOTPDeactivateModal = ({ visible, onCancel, userEmail, onSuccess }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    
    // Get user token from localStorage
    const getUserToken = () => {
        const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
        return userInfo.token;
    };

    const handleDisable = async (values) => {
        setLoading(true);
        try {
            const token = getUserToken();
            if (!token) {
                message.error('Authentication required');
                setLoading(false);
                return;
            }
            
            await axios.post('/dotnet_api/v1/auth/disable-totp', {
                email: userEmail,
                code: values.code
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            onSuccess();
            onCancel();
        } catch (error) {
            message.error('Invalid code');
        }
        setLoading(false);
    };

    const handleCancel = () => {
        form.resetFields();
        onCancel();
    };

    return (
        <Modal
            title="Disable Two-Factor Authentication"
            open={visible}
            onCancel={handleCancel}
            footer={null}
            width={400}
        >
            <Space direction="vertical" size="large" style={{ width: '100%' }}>
                <Alert
                    message="Security Warning"
                    description="Disabling TOTP will reduce your account security. You can re-enable it anytime."
                    type="warning"
                    icon={<ExclamationCircleOutlined />}
                    showIcon
                />
                
                <div style={{ textAlign: 'center' }}>
                    <Title level={4}>Disable TOTP Authentication</Title>
                    <Text type="secondary">
                        Enter a valid code from your authenticator app to disable TOTP
                    </Text>
                </div>
                
                <Form form={form} onFinish={handleDisable} layout="vertical">
                    <Form.Item
                        name="code"
                        label="Enter 6-digit code"
                        rules={[{ required: true, message: 'Please enter the code' }]}
                        style={{ display: 'flex', justifyContent: 'center' }}
                    >
                        <OTP
                            size="large"
                            length={6}
                            placeholder="Enter code"
                        />
                    </Form.Item>
                    
                    <Form.Item>
                        <Button
                            type="primary"
                            danger
                            htmlType="submit"
                            loading={loading}
                            block
                        >
                            Disable TOTP
                        </Button>
                    </Form.Item>
                </Form>
            </Space>
        </Modal>
    );
};

export default TOTPDeactivateModal;
